export const scheduleSchema = {
    displayName: 'schedule',
    type: 'object',
    fields: {
        from: {
            type: 'object',
            required: true,
            fields: {
                hours: {
                    type: 'int',
                    min: 0,
                    max: 23,
                },
                minutes: {
                    type: 'int',
                    min: 0,
                    max: 59,
                },
            },
        },
        to: {
            type: 'object',
            required: true,
            fields: {
                hours: {
                    type: 'int',
                    min: 0,
                    max: 23,
                },
                minutes: {
                    type: 'int',
                    min: 0,
                    max: 59,
                },
            },
        },
    },
};
//# sourceMappingURL=schedule_schema.js.map